// extracted by mini-css-extract-plugin
export default {"primaryColor":"#99de8d","primaryColorWithAlpha":"rgba(153,222,141,.1019607843)","mainBgColor":"#fff","secondBgColor":"#f5f5f5","secondaryColor":"#f5f5f5"};